<template>
  <div>
    <main-layout>
      <Mainmenu />
      <v-container>
        <div>
          <h1>{{ $t('company_management') }}</h1>
        </div>
        <div class="pt-3 text-xs-right">
          <v-btn dark depressed color="primary" @click="showManage = true">
            <em class="fa fa-plus pr-2" />
            <span>{{ $t('create_company') }}</span></v-btn
          >
          <v-btn dark outline color="primary" :loading="exportLoading" @click="handleExportXlsx">
            <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
          </v-btn>
        </div>
        <div>
          <v-data-table
            :headers="headers"
            :items="dataList"
            :pagination.sync="pagination"
            class="elevation-1 mt-3"
          >
            <template #items="props">
              <tr>
                <td>{{ props.item.project_id || '-' }}</td>
                <td>{{ props.item.company_code || '-' }}</td>
                <td>{{ props.item.company_name || '-' }}</td>
                <td>{{ props.item.team_id || '-' }}</td>
                <td class="text-xs-right">
                  <v-btn fab small outline color="primary" @click="handleEdit(props.item)">
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <v-btn fab small outline color="error" @click="handleDelete(props.item)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                  <v-btn dark small color="primary" @click="handleShowBranch(props.item.id)">
                    <v-icon>list</v-icon>
                    <span class="pl-2">{{ $t('branch') }}</span>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>

        <v-dialog v-model="showManage" persistent width="500">
          <v-card class="pa-3">
            <CompanyManage
              v-if="showManage"
              v-model="selectedCompany"
              :form-type="formType"
              @close="
                showManage = false
                selectedCompany = null
              "
              @success="handleManageSuccess"
            ></CompanyManage>
          </v-card>
        </v-dialog>
      </v-container>
    </main-layout>
  </div>
</template>

<script>
import rootsApi from '@/api/roots'
import Mainmenu from './Mainmenu'
import { mapGetters } from 'vuex'
import * as XLSX from 'xlsx'
import CompanyManage from './CompanyManage'

export default {
  components: {
    Mainmenu,
    CompanyManage
  },
  data() {
    return {
      limit: 10,
      offset: 0,
      pagination: { rowsPerPage: 10, sortBy: 'id' },
      total: 0,
      pagetmp: 1,
      pageNumber: 1,
      headers: [
        { text: this.$t('project_id'), value: 'project_id', sortable: false },
        { text: this.$t('company_code'), value: 'company_code', sortable: false },
        { text: this.$t('company_name'), value: 'company_name', sortable: false },
        { text: this.$t('team_id'), value: 'team_id', sortable: false },
        { text: '', value: '', sortable: false }
      ],
      isExport: false,
      dataList: [],
      showManage: false,
      exportLoading: false,
      formType: 'add',
      selectedCompany: null
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        let total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.handleGetCompany()
  },
  methods: {
    async handleGetCompany() {
      const vm = this
      try {
        const response = await vm.getCompany()

        if (response && response.status === 200) {
          vm.dataList = response.data.data
          vm.$store.state.rootsMasterData.company = response.data.data
          vm.total = response.data.total
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getCompany() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await rootsApi.getCompany({
          pageId: vm.selectedBot.pageid
        })
        vm.$store.dispatch('loading')

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        vm.$store.dispatch('loading')
        console.error(error)
        return null
      }
    },
    async handleExportXlsx() {
      const vm = this
      try {
        vm.isExport = true
        const response = await vm.getCompany()
        const requestData = response.data.data
        vm.isExport = false

        if (requestData == null) return
        const requests = requestData.map((el) => {
          return {
            id: el.id,
            project_id: el.project_id,
            company_code: el.company_code,
            company_name: el.company_name,
            team_id: el.team_id
          }
        })

        const heading = [['ลำดับที่', 'รหัสโปรเจ็ค', 'ชื่อย่อบริษัท', 'ชื่อบริษัท', 'รหัสทีม']]

        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.json_to_sheet([])
        XLSX.utils.sheet_add_aoa(ws, heading)
        XLSX.utils.sheet_add_json(ws, requests, { origin: 'A2', skipHeader: true })
        XLSX.utils.book_append_sheet(wb, ws)
        XLSX.writeFile(wb, `company-list.xlsx`)
      } catch (error) {
        console.error(error)
      }
    },
    handleChangePage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit

        vm.getData()
      }
    },
    handleEdit(item) {
      this.selectedCompany = item
      this.showManage = true
      this.formType = 'edit'
    },
    handleManageSuccess() {
      this.showManage = false
      this.selectedCompany = null
      this.handleGetCompany()
    },
    async handleDelete(item) {
      const vm = this
      try {
        const result = await vm.$swal.fire({
          title: this.$t('Do you want to delete this?'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })

        if (result.value) {
          const response = await vm.deleteCompany(item.id)
          if (response && response.status === 200) {
            this.handleGetCompany()
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    async deleteCompany(id) {
      const vm = this
      try {
        let data = {
          id: id
        }
        const response = await rootsApi.deleteCompany({
          config: data,
          pageId: vm.selectedBot.pageid
        })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    handleShowBranch(companyId) {
      this.$router.push(`company-management/${companyId}`)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/Roots/CompanyManagement.vue